import { validateCard } from "business-layer/helpers/creditCards";

export const requiredField = {
  required: {
    value: true,
    message: 'Required field.',
  },
};

export const cvvField = {
  custom: {
    isValid: (value: string) => !value || value?.length === 0 || value?.length > 2,
    message: '3 digits min.',
  },
};

export const tocField = {
  custom: {
    isValid: (value: string) => Boolean(value),
    message: 'Required field.',
  },
};

export const cardNumField = {
  custom: {
    isValid: (value: string) => validateCard(value),
    message: 'Invalid number.',
  },
};
